import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../../styles";
import { classNames } from "../../../../utils";
export const OpenSeaLogo = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = classNames(fillVariants({
      fill: "current"
    }), className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M15.1312285,0.000519644168 C23.2763415,0.071020638 29.9319337,6.72661331 29.9994346,14.8687262 C30.0714356,23.2568425 23.2568412,30.0714369 14.8687249,29.9994359 C6.72511202,29.931935 0.0710206168,23.2763427 0.000519644585,15.1312298 C-0.0684813169,6.74311354 6.74311227,-0.0684812958 15.1312285,0.000519644168 Z M14.9782264,4.63408431 C14.441219,4.63408431 14.006213,5.06909034 14.006213,5.60609778 L14.006213,6.12360495 C13.1722014,5.87910157 12.2871891,5.69459901 11.3616763,5.58659751 C12.8916975,7.24862055 13.8262105,9.47165137 13.8262105,11.9091852 C13.8262105,14.0947154 13.0792001,16.1017433 11.8236827,17.6917653 L14.006213,17.6917653 L14.006213,19.5517911 L10.8111687,19.5517911 C10.3776627,19.5517911 10.0281578,19.2007862 10.0281578,18.7687802 L10.0281578,17.955769 C10.0281578,17.813267 9.91415623,17.6962654 9.76865421,17.6962654 L5.55659582,17.6962654 C5.47409468,17.6962654 5.40359306,17.7637663 5.40359306,17.8462675 C5.40209368,21.1733136 8.03463017,23.6708482 11.1816738,23.6708482 L20.069297,23.6708482 C22.1993265,23.6708482 23.1518397,20.9408103 24.399857,19.2037863 C24.8843637,18.531777 26.0468799,17.9917695 26.3993847,17.8417674 C26.4638856,17.814767 26.5013862,17.7547662 26.5013862,17.6842652 L26.5013862,16.6027502 C26.5013862,16.4932487 26.3948847,16.4107476 26.2868832,16.440748 C26.2868832,16.440748 25.1580223,16.6998092 23.9524278,16.9769157 L23.4685914,17.0881494 C22.261239,17.3657833 21.1174365,17.6293269 21.0893111,17.6377646 C21.0293103,17.6557648 21.00681,17.6902653 21.00681,17.6902653 C20.4878028,18.387775 19.3927876,19.545791 18.7822792,19.545791 L15.9517399,19.545791 L15.9517399,17.6887653 L18.2062712,17.6887653 C18.5287756,17.6887653 18.8362799,17.5582635 19.058283,17.3287603 C20.214799,16.1287436 20.8853083,14.7022239 20.8853083,13.1692026 C20.8853083,10.5561664 18.9322812,8.24613438 15.9502399,6.85411508 L15.9502399,5.60609778 C15.9502399,5.06909034 15.5152339,4.63408431 14.9782264,4.63408431 Z M10.6446664,7.46462354 L5.81009934,15.8302395 L11.0106714,15.8302395 C11.7501817,14.7037239 12.1806876,13.3537052 12.1806876,11.9031851 C12.1806876,10.2291619 11.6061797,8.68564047 10.6446664,7.46462354 Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t4 = <svg aria-label="OpenSea" className={t2} fill="currentColor" height={size} viewBox="0 0 30 30" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};